<template>
  <div
    id="iq-sidebar"
    class="iq-sidebar"
  >
    <div
      class="iq-sidebar-logo d-flex justify-content-end align-items-center"
      style="min-height: 77px;"
    >
      <div
        class="iq-menu-bt-sidebar"
        style="margin-top: 17px;"
      >
        <div
          class="iq-menu-bt align-self-center p-2 rounded-lg"
          style="padding-left: 15px !important; padding-right: 15px !important;"
        >
          <div
            class="wrapper-menu"
            @click="toggleSidebar"
          >
            <div class="main-circle">
              <i
                class="fad fa-chevron-left text-dark"
                style="font-size: 19px;"
              />
            </div>
            <div class="hover-circle">
              <i
                class="fad fa-close text-dark"
                style="font-size: 19px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="sidebar-scrollbar">
      <nav class="iq-sidebar-menu">
        <CollapseMenu
          :items="sidebarMenus"
          :open="true"
          :sidebar-group-title="true"
        />
      </nav>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { core, APPNAME } from '@/config/pluginInit'
import { getSidebarMenus } from '@/router/navigation'
import CollapseMenu from '@/components/core/menus/CollapseMenu'

export default {
  name: 'Sidebar',

  components: {
    CollapseMenu
  },

  data () {
    return {
      appName: APPNAME
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),

    sidebarMenus () {
      if (this.user) {
        return getSidebarMenus(this.user)
      }

      return []
    }
  },

  mounted () {
    core.smoothScrollbar()
  },

  methods: {
    toggleSidebar () {
      core.triggerSet()
    }
  }
}
</script>
